import { useDate, useName } from '@bechtel/client-common';
import { Box, Icon, IconSize, Text } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import { Trans, t } from '@lingui/macro';
import { FC } from 'react';
import { CountMetadata, UserMetadata } from '../../../metadata';
import { WeldMilestoneMetadataProps } from './types';

const UnassignedCrewMember = () => {
  return (
    <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }}>
      <Icon size={IconSize.MEDIUM} icon="user" fillColor="blue.800" />
      <Box ml={{ sm: '500' }}>
        <Text size="400" color="grey.1000">
          <Trans>Unassigned</Trans>
        </Text>
      </Box>
    </Box>
  );
};

export const WeldMilestoneMetadata: FC<WeldMilestoneMetadataProps> = ({
  milestone,
  status,
  assignee,
  isFitupMilestone,
  isFitupRequired,
}) => {
  const { formatISODate } = useDate();
  const { getFullName } = useName();
  if (
    (status === MilestoneStatusCode.CLAIMED || status === MilestoneStatusCode.APPROVED) &&
    milestone.currentStatus &&
    milestone.currentStatus.createdBy
  )
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );

  if (status === MilestoneStatusCode.REQUESTED && milestone.currentStatus && milestone.currentStatus.createdBy)
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );
  if (status === MilestoneStatusCode.BLOCKED && milestone.currentStatus && milestone.currentStatus.createdBy)
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );

  if (status === MilestoneStatusCode.REJECTED) {
    return (
      <Box gap={{ sm: '200' }} flexDirection={{ sm: 'column' }}>
        {(!isFitupMilestone || (isFitupMilestone && isFitupRequired)) && (
          <CountMetadata label={t`Rejection Count`} count={milestone.timesRejected} />
        )}
        <UserMetadata
          name={getFullName(milestone.currentStatus.createdBy?.firstName, milestone.currentStatus.createdBy?.lastName)}
          imageUrl={milestone.currentStatus.createdBy?.imageUrl}
          startDate={formatISODate(milestone.currentStatus.createdAt)}
        />
      </Box>
    );
  }

  if (assignee)
    return <UserMetadata name={getFullName(assignee.firstName, assignee.lastName)} imageUrl={assignee.imageUrl} />;
  if (!assignee) return <UnassignedCrewMember />;
  return null;
};
